import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from 'primereact/inputswitch';
import { useDispatch } from 'react-redux';
import AddEditGateway from './AddEditGateway';
import { endPoints } from '../../Config';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import ActiveInactiveDialog from '../../components/ActiveInactiveDialog';

const GatewayList = () => {
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [rowRecord, setRowRecord] = useState(null);
    const [allgateWays, setAllGateWays] = useState([]);
    const [editable, setEditable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const [switchData, setSwitchData] = useState(null);
    const [switchModal, setSwitchModal] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();

    const handleAdd = () => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(false);
    };

    const handleEdit = (rowData) => {
        setShowAddDialog(true);
        setEditable(true);
        setViewable(false);
        setRowRecord(rowData);
    };

    const handleView = (rowData) => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(true);
        setRowRecord(rowData);
    };
    const handleInputSwitch = async () => {
        setLoadingBtn(true);

        let data = {
            isActive: switchData?.isActive ? false : true
        };

        const response = await dispatch(handlePutRequest(data, endPoints?.updateMerchant, false, true));

        if (response?.status === 200) {
            getGateWayList();
        }

        setLoadingBtn(false);
        handleSwitchModalClose();
    };

    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };

    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <InputSwitch
                        checked={rowData.status}
                        onChange={() => {
                            handleSwitchModalOpen();
                            setSwitchData(rowData);
                        }}
                    />
                    <Button
                        tooltip="Edit"
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                        onClick={() => {
                            handleEdit(rowData);
                        }}
                        className="p-button-rounded p-button-primary mr-2 ml-2"
                    />
                    <Button
                        tooltip="View Details"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        onClick={() => {
                            handleView(rowData);
                        }}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                </div>
            </>
        );
    };

    const getGateWayList = async () => {
        const response = await handleGetRequest(endPoints.getallPaymentGateways, true, false, dispatch);
        if (response) {
            setAllGateWays(response?.data);
        }
    };

    useEffect(() => {
        getGateWayList();
    }, []);

    const onHide = () => {
        setShowAddDialog(false);
        getGateWayList();
    };
    const onCancel = () => {
        setShowAddDialog(false);
    };

    // const dobTemplate = (rowData) => {
    //     const isoDate = rowData?.dateOfBirth;
    //     const date = new Date(isoDate);

    //     const mm = String(date.getMonth() + 1).padStart(2, '0');
    //     const dd = String(date.getDate()).padStart(2, '0');
    //     const yyyy = date.getFullYear();

    //     const formattedDate = `${dd}/${mm}/${yyyy}`;
    //     return <p>{formattedDate}</p>;
    // };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>GateWays</h3>
                <div className="flex gap-2">
                    <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} />
                </div>
            </div>
            <Dialog header={<div>{editable ? 'Edit GateWay' : viewable ? 'View GateWay' : 'Add GateWay'}</div>} visible={showAddDialog} onHide={onCancel} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }}>
                <AddEditGateway rowRecord={rowRecord} editable={editable} viewable={viewable} onHide={onHide} onCancel={onCancel} />
            </Dialog>
            <ActiveInactiveDialog visible={switchModal} onHide={handleSwitchModalClose} onConfirm={handleInputSwitch} onCancel={handleSwitchModalClose} status={switchData?.isActive} />

            <DataTable
                paginator
                rows={15}
                rowsPerPageOptions={[5, 10, 20]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                emptyMessage="No List found."
                responsiveLayout="scroll"
                value={allgateWays}
                className="p-datatable-sm datatable-responsive"
            >
                <Column field="name" header="Name" />
                <Column field="rate" header="Rate" />
                <Column field="testMode" header="Test Mode" />
                <Column field="supportedCurrencies" header="Supported Currencies" />
                <Column field="charge" header="Charge" />
                <Column field="customerStatus" header="Customer Status" />
                <Column field="globalStatus" header="Global Status" />
                <Column field="acceptImage" header="Accept Image" />
                <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        </div>
    );
};

export default GatewayList;
